// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/image 41-bplam.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bplam-Main-comp {
  display: flex;
  font-family: 'Graphik', sans-serif;
  flex-direction: column;
  text-align: center;

}

.bplam-screen-container {
  /* margin-left: 100px; */
  width: 100%;
  height: 260px;
  text-align: center;
  /* background-color: #142038; */
  background-color: transparent;
}

.bplam-screen {
  width: 95%;
  height: 100%;
}

.img-class-comp-bplam {

  margin-left: 900px;
  margin-right: 5px;
  /* width: 1150px; */
  width: 20px;
}

.img-class-comp2-bplam {

  margin-left: 800px;
  margin-right: 5px;
  width: 900px;
  width: 20px;
}

.header-comp {
  width: 1280px;
  height: 54px;
}

.header-comp2 {
  width: 1263px;
  height: 53px;
}

.bplam-bottom-comp {
  display: flex;
  flex-direction: column;
  /* background-color: #142038; */
  background-color: transparent;
  padding-top: 5px;
}

.left-comp {
  display: flex;
  flex-direction: column;
}

.section-dropdown {
  width: 140px;
  margin-right: 20px;
  margin-top: 15px;
  max-height: 20px;

}

multiSelectContainer input::placeholder {
  color: black;
}

.checkbox {
  margin-right: 10px;
}

.optionContainer {
  color: black;
}

.chip {
  display: none;
}

.optionListContainer {
  background-color: #202342;
  border-radius: 4px;
  font-family: 'Graphik';
  font-size: 12px;
  color: black;
  margin-top: 1px;
  position: absolute;
  width: 100%;
  z-index: 2;
}

.searchWrapper {
  max-width: 150px;
  background-color: white;
  border-radius: 10px;
  border: 1px solid black;
  font-family: 'Graphik';
  color: black;
  font-size: 12px;
  overflow: hidden;
  max-height: 26px;
}

.title-box-comp {
  width: 550px;
  font-size: 13px;
  font-family: 'Graphik';
  border-radius: 5px;
  border: 2px solid white;
  margin-left: 20px;
  margin-top: 5px;
}

/* .right-comp{
  background-color:rgba(255, 255, 255, 0.03);
  border-radius:10px;
  width:100%;
  margin-right:20px;
  margin-top:10px;
  margin-left:35px;
}
.under-generate-comp{
  background-color:rgba(255, 255, 255, 0.1);
  
  margin-top:10px;
  width:100%;

  margin-left: 20px;
  border-radius: 10px;
}
.loader-c {
  display: flex;
  margin-left:150px;
  justify-content: center;
  align-items: center;
  height: 40px;
}

.dot-cq {
  width: 10px;
  height: 10px;
  margin: 0 5px;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.4s infinite ease-in-out;
}
*/
/*
.red-c {
  background-color: red; 
  animation-delay: -0.32s;
}

.green-c {
  background-color:green; 
  animation-delay: -0.16s;
}
.blue-c {
  background-color: blue; 
 
}
.f-comp{
  color:white;
  font-weight:500;
  padding-left:10px;
  padding-bottom:5px;
  padding-top:5px;
}
.f2-comp{
  color:white;
  font-weight:500;
  padding-left:20px;
  padding-bottom:5px;
  padding-top:5px;
}
.report-table{
  max-height:400px;
 
  margin-left:20px;
 
}
.report-table thead {
    padding-left: 15px;
  position: sticky;
  top: 0;
  background-color: #202342; 
  
  color: white; 
}
.report-table-container{
  overflow-y: scroll;
  max-height: 350px;
  max-width: 1150px;
}
.report-table th{
 padding-left: 30px;
  height:40px;
  overflow: None;
  color:white;
  font-size: 14px;
  background-color:rgba(255, 255, 255, 0.1);
font-style: normal;
font-weight: 500;
line-height: normal;
  border:1px solid rgba(0, 0, 0, 0.10);
  border-bottom:1px solid rgba(0, 0, 0, 0.10);
}
.report-table td {
border:  1px solid rgba(0, 0, 0, 0.10); 
padding: 8px; 
font-family: 'Graphik', sans-serif;
color: white;
text-align: left;
font-size: 12px;

font-style: normal;
font-weight: 300;
line-height: normal;
}
.f3-comp{
  color:white;
  font-weight:500;
  padding-left:20px;
  padding-bottom:5px;
  padding-top:15px;
}
.above-comp{
  padding-bottom:30px;
  border-bottom:1px solid #8392B6;
}
.r2-comp{
  display:flex;
  flex-direction:row;
  padding-left:10px;
}
.p-comp{
  color:white;
  background-color:#D8AC1B;
  flex-shrink: 0;
  padding-left:10px;
  font-size:10px;
  padding-top:3px;
  height:20px;
  padding-right:10px;   
  border-radius:12px;
  margin-right:10px;
}
.p1-comp{
  color:white;
  padding-top:3px;
  background-color:#24B600;
  flex-shrink: 0;
  padding-left:10px;
  font-size:10px;
  height:20px;
  padding-right:10px;   
  border-radius:12px;
  margin-right:10px;
}
.d-comp{
  color:white;
  font-size:12px;
  padding-bottom:5px;
}
.generate-comp{
  margin-left: 25px;
  font-size: 15px;
  font-weight: 500;
  margin-top: 10px;
  color: white;
}
.r1-comp{
  display:flex;
  flex-direction:row;
}
.n2-comp{
  display:flex;
  margin-top:10px;
  flex-direction:row;
}
.in-comp{
  margin-top:8px;
  padding-right:200px;
  font-size:13px;
  padding-top:10px;
  font-weight: 300;
  padding-left:80px;
  color:white;
} */
/* .drop-comp{
  width:200px;
  border-radius:10px;
  margin-top:15px;
} */
/* .search-insight-bplam{
  margin-left: 10px;
} */
.bplam-insight-filter {
  border-bottom: 1px solid #AD8BFF;

}

.ref-comp {
  color: #FFF;
  padding-left: 20px;
  padding-top: 15px;
  font-size: 14px;
  padding-right: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.file-comp {
  color: #FFF;
  padding-top: 18px;
  font-size: 12px;
  padding-right: 150px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
}

.n1-comp {
  background-color: rgba(0, 0, 0, 0.10);
  display: flex;
  border-radius: 5px;
  margin-top: 10px;
  height: 50px;
  width: 1140px;
  flex-direction: row;
  margin-left: 20px;
  color: white;
  flex-shrink: 0;
}

.generate1-comp {
  margin-left: 10px;
  padding-bottom: 10px;
  font-family: 'Graphik';
  font-size: 15px;
  font-weight: 500;
  border-bottom: 1px solid #8392B6;
  margin-top: 5px;
  color: white;
}

.Heading-comp-bplam {
  color: #fff;
  font-size: 12px;
  font-family: 'Graphik';
  display: flex;
  flex-direction: row;
  padding-top: 5px;
  padding-left: 15px;
  padding-right: 10px;
  padding-bottom: 5px;
  /* background-color: #142038; */
  background-color: transparent;
  width: 100%;
}

.screen-change1-bplam {
  color: #AD8BFF;
  width: 120px;
  font-family: 'Graphik';
  padding-right: 5px;

}

.screen-change1-bplam1 {
  color: #AD8BFF;
  /* width: 50px; */
  font-family: 'Graphik';
  padding-right: 5px;
  margin-left: 10px;
}

.bplam-comp {
  font-family: 'Graphik';
  color: #FFFFFF;
  width: 160px;
  padding-right: 5px;
}

.bplam-comp1 {
  font-family: 'Graphik';
  color: #FFFFFF;
  /* width: 50px; */
  padding-right: 5px;
}

.button-comp-bplam {
  text-align: right;
  /* margin-top:10px; */
  margin-bottom: 10px;
  border-radius: 10px;
  margin-right: 30px;
}

.sub-heading-comp {
  margin-left: 20px;
  font-size: 15px;
  font-weight: 400;
  font-family: 'Graphik';
  margin-top: 20px;
  color: white;
}

.b-c-bplam {
  background-color: #6B5CD1;
  border: 2px solid #6B5CD1;
  color: white;
  font-size: 12px;
  font-family: 'Graphik';
  height: 30px;
  border-radius: 26px;
  width: 200px;
  /* margin-top: 5px; */
}

.b-c:hover {
  background-color: #343434;
  border: 2px solid #343434;
}

.b1-c {
  background-color: #6B5CD1;
  border: 2px solid #6B5CD1;
  margin-left: 60px;
  color: white;
  font-family: 'Graphik';
  margin-top: 15px;
  margin-right: 20px;
  height: 30px;
  border-radius: 26px;
  width: 120px;
}

.b1-c:hover {
  background-color: #343434;
  border: 2px solid #343434;
}

.b2-c {
  background-color: #6B5CD1;
  border: 2px solid #6B5CD1;
  color: white;

  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  height: 30px;
  border-radius: 26px;
  width: 120px;
}

.b2-c:hover {
  background-color: #343434;
  border: 2px solid #343434;
}

.b3-c {
  background-color: #6B5CD1;
  text-decoration: none;
  border: 2px solid #6B5CD1;
  color: white;
  font-family: 'Graphik';

  margin: 10px;
  height: 30px;
  border-radius: 26px;
  width: 120px;
}

.b3-c:hover {
  background-color: #343434;
  border: 2px solid #343434;
}

.dropdown-comp {
  display: flex;
  margin-top: 10px;
  flex-direction: row;
}

.img-comp {
  width: 60%;
  margin-left: 10px;
}

.first-select-comp {
  display: flex;
  flex-direction: column;
}

.first-input-comp {
  display: flex;
  margin-left: 20px;
  width: 270px;
  flex-direction: row;
}

/* Add this CSS to your styles or create a new CSS file */
.popup-bplam {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

}

.popup-content-bplam {
  background: #1E203D;
  color: white;
  font-family: 'Graphik';
  padding: 5px;
  /* border-radius: 8px; */
  border: 1px solid #AD8BFF;
  border-radius: 10px;
  height: 75%;
  width: 35%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.headers-bplam {
  background-color: #282c5b;
  /* padding-left: 30px;
  padding-right: 30px; */
  padding-top: 1px;
  padding-bottom: 10px;
  width: 100%;
  height: 40px;
  border-radius: 8px;
  text-align: left;
}

.bplam-close-btn {
  position: absolute;
  top: 75px;
  right: 420px;
  font-family: 'Graphik';
  font-size: 30px;
  cursor: pointer;
  color: #6B5CD1;
  background-color: rgba(255, 255, 255, 0.0);
  border: 0px solid rgba(255, 255, 255, 0.0);
}

.drop-down-sel-bplam {
  height: 25px;
  width: 370px;
}

.div-container-bplam {
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 20px;
  text-align: left;

}

.title-bplam {
  margin-top: 2px;
  height: 30px;
  width: 200px;
  font-family: 'Graphik';
  /* font-weight: bold; */
  font-weight: 600;
  font-size: 15px;
}

.text-bplam {
  margin-top: 2px;
  height: 25px;
  width: 370px;
}

.company-bplam {
  margin-top: 2px;
  height: 30px;
  width: 200px;
  font-family: 'Graphik';
  /* font-weight:bold; */
  font-weight: 600;
  font-size: 15px;

}

.dropdown-bplam {
  margin-top: 2px;
  height: 25px;
  width: 450px;
}

.t-data-bplam {
  margin-top: 5px;
  height: 30px;
  width: 200px;
  font-family: 'Graphik';
  /* font-weight: bold; */
  font-weight: 600;
  font-size: 15px;

}

.browse {
  margin-top: 5px;
  height: 30px;
  width: 200px;
}

.analyse-bplam {
  /* font-weight: bolder; */
  font-weight: 600;
  font-family: 'Graphik';
  margin-top: 10px;
  margin-left: 20px;
}

.p-gen-bplam {
  margin-left: 25px;
  margin-right: 20px;
  font-size: 12px;
  text-align: left;
}

.drags-bplam {

  margin-right: 2px;

  font-size: 12px;

}

.browses-bplam {

  /* margin-left: 5px; */
  border: 1px solid #707070;
  border-radius: 10px;
  width: 80%;
  height: 30px;
  font-family: 'Graphik';
  font-size: 12px;
  padding: 5px 25px;
  margin: 5px 10px 5px 45px;
  /* margin-top: 50px; */
  /* margin-left: 30px; */
  /* background-color: #747BA9; */
  background-color: rgba(116, 123, 169, 0.7);
  color: #FFFFFF;

}

.drag-select-container-bplam {
  padding-top: 5px;
  /* padding-bottom: 5px; */
  border: 1px solid #707070;
  background-color: rgba(116, 123, 169, 0.1);
  padding-left: 10px;
  /* background-color: #8392B6; */
  height: 50px;
  border-radius: 10px;
  text-align: center;
  width: 370px;
  margin-bottom: 1px;
  /* margin-left: 280px; */

  display: flex;

  flex-direction: row;

}

.footer-bplam {
  background-Color: #EFEFEF;
  color: #707070;
  padding: 5px;
  height: 25px;
  text-align: center;
  font-size: 10px;
  font-family: 'Graphik';
}

.submit1-bplam {
  width: 90%;
  height: 30px;
  border: 1px solid #707070;
  border-radius: 10px;
  background-color: #738395;
  color: #FFFFFF;
  font-family: 'Graphik';
}

.bplam-drill-card {
  /* background-color: #3C4069; */
  background-color: #3C4069;
  border: 1px solid #747BA9;
  border-radius: 8px;
  /* min-width: 260px; */
  width: 260px;
  height: 130px;
  margin: 10px;
}

.bplam-drill-card-body {
  padding: 15px 10px;
}

.bplam-view-report {
  width: auto;
  float: right;
  cursor: pointer;
  background-color: rgba(107, 92, 209, 1);
  color: rgba(255, 255, 255, 1);
  font-family: 'Graphik';
  font-size: 12px;
  font-weight: 400;
  padding: 2% 4%;
  border: none;
  border-radius: 10dvh;
  margin-top: -40px;
}

.report-icon {
  width: 20px;
  margin-top: 1px;
  height: 15px;
}

.bplam-status-drill {
  max-width: fit-content;
  margin-top: -6px;
  padding: 1% 3%;
  height: fit-content;
  background-color:  rgba(36, 182, 0, 1);
  color: rgba(255, 255, 255, 1);
  font-family: Graphik;
  font-size: 11px;
  font-weight: 300;
  border: none;
  border-radius: 8dvh;
  margin-top: 15px;
  

}

.bplam-drill-header {
  color: aliceblue;
  font-family: 'Graphik';
  font-weight: 600;
  font-size: 11px;
  line-height: 5px;
  text-align: left;
  /* height: 50px; */
}

.bplam-drill-body {
  color: aliceblue;
  text-align: left;
  font-family: 'Graphik';
  font-weight: 400;
  font-size: 12px;
  line-height: 5px;
}

.bplam-drillanalysis-report {
  padding-left: 20px;
  padding-top: 10px;
  /* margin-left: 20px;
  margin-right: 20px; */
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #AD8FFF;
}

.bplam-Bottom2 {
  /* background-color: #142038; */
  background-color: transparent;
  display: flex;
  flex-direction: row;
  margin-left: 50px;
}

.bplam-bottom-cont {
  padding-top: 15px;
  padding-bottom: 15px;
  background-color: rgba(255, 255, 255, 0.1);
  margin-left: 30px;
  width: 95%;
  /* border:1px solid white; */
  border-radius: 10px;
  margin-bottom: 5px;
}

.bplam-filter-button {
  width: 70px;
  margin-left: -10px;
  color: #738395;
  font-family: 'Graphik';
  font-size: 12px;
  margin-right: 10px;
  margin-top: 6px;
}

.bplam-filter-button1 {
  /* width: 100px; */
  margin-left: -20px;
  color: #747BA9;
  margin-right: 5px;
  font-family: 'Graphik';
  font-size: 25px;
  margin-top: -5px;
}

.bplam-status-dd {
  border-style: solid;
  border-width: 1px;
  border-radius: 50px;
  border-color: #AD8BFF;
  height: 20px;
  width: 100px;
  background-color: transparent;
  margin-left: 10px;
  margin-top: 5px;
}

.tab-content-bplam {
  /* background-color: #142038; */
  background-color: transparent;
}

.tab-buttons-bplam {
  /* background-color: #142038; */
  background-color: transparent;
  padding-left: 15px;
  padding-right: 50px;
  padding-top: 2px;
  padding-bottom: 2px;
  text-align: left;
  width: 100%;

  flex-direction: row;
  display: flex;
}

.tab-button.active {
  background-color: #2ecc71;
  color: #ffffff;
  border-bottom: 2px solid #6B5CD1;
}

.bottom-comp-t1 {
  height: 80vh;
  overflow-y: auto;
  border-radius: 10px;
  padding: 5px;
  background-color: transparent;
  width: 94vw;
}

.b-upper-ct1 {
  height: 600px;
  width: 100%;
  margin: 5px;
  display: flex;
  flex-direction: row;
  overflow-y: hidden;
}



.b-lower-comp-t1 {
  /* height:50%; */
  height: 660px;
  width: 99%;
  margin-top: 10px;
  padding-top: 10px;

  margin-right: 5px;
  margin-left: 15px;
  margin-bottom: 5px;
  border-radius: 10px;
  padding-left: 15px;
  padding: 5px 50px 5px 50px;
  /* background-color: rgba(116,123,169,0.5); */
  background-color: rgba(255, 255, 255, 0.1);
}

.b-u-left-ct1 {
  height: 600px;
  margin: 5px;
  width: 60%;
  border-radius: 10px;
  /* background-color: rgba(116,123,169,0.5); */

}

.b-u-l-upper-ct1 {
  height: 80px;
  width: 98%;
  border-radius: 10px;
  margin-top: 10px;
  margin: 5px;
  /* background-color: rgba(116,123,169,0.5); */
  background-color: rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
}

.images-t1 {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
}

.b-u-l-u-ct1-header {
  color: #FFFFFF;
  font-family: 'Graphik', sans-serif;
  /* font-family: 'Graphik'; */
  font-size: 14px;
  /* font-weight: bold; */
  margin-right: 470px;
  padding: 2px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.b-u-l-lower-ct1 {
  height: 495px;
  width: 98%;
  margin-top: 10px;
  margin-bottom: 5px;
  margin-left: 5px;
  margin-right: 5px;
  padding-top: 5px;
  border-radius: 10px;
  /* background-color: rgba(116,123,169,0.5); */
  background-color: rgba(255, 255, 255, 0.1);
}

.b-u-right-ct1 {
  height: 585px;
  width: 40%;
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 10px;
  margin-top: 10px;
  /* margin-bottom:5px; */
  /* background-color: rgba(116,123,169,0.5); */
  background-color: rgba(255, 255, 255, 0.1);
}

.b-u-r-ct1-header1 {
  font-family: 'Graphik';
  font-size: 15px;
  color: #FFFFFF;
  text-align: left;
  margin: 15px 0px 0px 10px;
}

.b-u-r-ct1-header2 {
  font-family: 'Graphik';
  font-size: 8px;
  color: #FFFFFF;
  margin-left: 20px;
  text-align: left;
}
.bplam-header-barchart-text{
  color: #FFFFFF;
  font-family: 'Graphik';  
  font-size: 9px; 
  margin-left: 10px;
}
.bplam-header-barchart{
  color: #FFFFFF;
  font-family: 'Graphik';   
  font-size: 14px;
  font-weight: 500;
  margin-left: 10px;
}
.date-range {
  border: 1px solid #6B5CD1;
  background-color: #6B5CD1;
  border-radius: 10px;
  padding: 5px;
  width: 45px;
  height: 40px;
  margin-left: 10px;
  margin-top: 2px;
}

.assecending-bplam {
  position: absolute;
  top: 50px;
  right: 50px;
  padding: 8px;
  background-color: transparent;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid #e6c520;
}

.date-range-text2 {
  font-size: 12px;
  /* margin-top: -15px; */
  text-align: left;
  margin-left: 10px;
  color: white;
}

.tot-ticket {
  border: 1px solid #6B5CD1;
  background-color: #6B5CD1;
  border-radius: 10px;
  padding: 7px;
  width: 45px;
  height: 40px;
  margin-top: 2px;
  /* margin-left: 65px; */
  margin-left: 120px;
}

.tot-apps {
  border: 1px solid #6B5CD1;
  background-color: #6B5CD1;
  border-radius: 10px;
  padding: 6px;
  width: 45px;
  height: 40px;
  /* margin-left: 70px; */
  margin-left: 120px;
  margin-top: 2px;
}

.date-range-text {
  color: #FFFFFF;
  font-family: 'Graphik';
  font-size: 14px;
  font-weight: bold;
  width: fit-content;
  margin-left: 10px;
  /* margin-bottom: 5px; */
}

.tot-tic-text {
  color: #FFFFFF;
  font-family: 'Graphik';
  font-size: 14px;
  font-weight: bold;
  margin: 1px;
}

.tot-tic-text2 {
  color: #FFFFFF;
  font-size: 12px;
  font-family: 'Graphik';
  /* margin: 3px; */
  width: fit-content;
}

.tot-app-text {
  color: #FFFFFF;
  /* font-family: 'Graphik'; */
  font-family: 'Graphik', sans-serif;
  font-size: 14px;
  font-weight: bold;
  margin: 1px;
}

.tot-app-text2 {
  color: #FFFFFF;
  font-family: 'Graphik', sans-serif;
  font-size: 10px;
  margin: 3px;
  width: fit-content;
}

.ts {
  margin-left: 10px;
  display: flex;
  flex-direction: column;
}

.hmt-header {
  background-color: rgba(255, 255, 255, 0.0);
  color: #FFFFFF;
  font-size: 14px;
  text-align: left;

  margin-top: 5px;
}

.heatmap-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  height: 93%;
}

.heatmap-table-th,
.heatmap-table-td {
  border: 1px solid #ddd;
  padding: 2px;
  text-align: center;
  font-size: 12px;

}

.heatmap-table-th {
  /* background-color: #f2f2f2; */
  background-color: rgb(107, 92, 209);
  height: 50px;
  color: #FFF;
  font-size: 12px;
  font-weight: 500;
  padding: 8px;
}

.heatmap-table-td {
  color: #FFFFFF;
  font-size: 12px;
}

.heatmap-table-td1 {
  /* background-color: purple; */
  background-color: rgb(54, 57, 85);
  color: #FFFFFF;
  font-size: 12px;
  border: 1px solid #ddd;
  padding: 8px;
  /* font-weight: bold; */
}

.heatmap-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.heatmap-table tbody tr:hover {
  background-color: #e5e5e5;
}

.nested-bplam {
  height: 300px;
  width: 400px;
}

.insights-table-bplam {
  color: white;

}

.bplam-insight-filter {
  display: flex;
  flex-direction: row;
  margin-left: 20px;

}

.bplam-insight-filter-cont {
  display: flex;
  flex-direction: row;
}

.bplam-insight-filter-label {
  color: white;
  font-size: 10px;
  font-weight: bold;
  font-family: 'Graphik', 'sans-serif';
}

.b-i-f-header {
  color: #738395;
  font-size: 12px;
  margin-top: 15px;
  margin-right: 10px;
  margin-left: 15px;
}

.bplam-tab2-insights {
  background-color: rgba(255, 255, 255, 0.1);
  padding: 10px;
  border: 1px solid rgba(116, 123, 169, 1);
  border-radius: 10px;
  width: 98%;
  margin: 10px 15px;
}

.bplam-tab2-insights-header {
  color: #FFFFFF;
  font-family: 'Graphik', 'sans-serif';
  font-weight: 500;
  text-align: left;
  margin-top: 10px;
  margin-left: 20px;
  margin-bottom: 10px;
}

/* .bplam-insight-filter-sel{
  height: 41px;
  width: 120px;
  border: 1.5px solid #AD8BFF;
  border-radius: 10px;
  background-color: #142038;
} */


/* FishboneChart.css */

/* Styling for the diagram widget container */
.DiagramWidget {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  overflow: hidden;
}

/* Styling for nodes */
.DiagramNode {
  background-color: #fff;
  border: 1px solid #999;
  padding: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

/* Styling for node labels */
.DiagramNode .name {
  font-size: 14px;
  font-weight: bold;
}

/* Styling for node ports */
.DiagramPort {
  background-color: #333;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

/* Styling for links */
.DiagramLink {
  stroke: #333;
  stroke-width: 2;
  fill: none;
  marker-end: url(#arrowhead);
}

/* Styling for link labels */
.DiagramLink .diagram-link-label {
  font-size: 12px;
  fill: #333;
}

/* Styling for link arrowhead */
#arrowhead {
  width: 10px;
  height: 10px;
  fill: #333;
}

/* Styling for node counts */
.DiagramNode .diagram-node-count {
  font-size: 12px;
  color: #333;
}

/* *, *::before, *::after {
  box-sizing: border-box;
  color: white;
} */
.rootCauses {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  flex: 3 1;
  font-size: 0.85em;
  font-weight: 400;
  color: #FFFFFF;
  text-align: right;
  padding: 10px 2px;
}

.cause.top.blue.blueBorder {
  color: white;
}

.cause.top.blue_.blueBorder {
  background: rgb(188, 1, 255, 0.9);
  color: #FFFFFF;
  border-color: #CD53AE !important;

}

.cause.bottom.blue_.blueBorder {
  background: rgb(105, 97, 178, 0.9);
  color: #FFFFFF;
  border-color: #CD53AE !important;
}

.effectValue {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.95em;
  font-weight: 400;
  color: #FFFFFF;
  padding: 5px 10px 5px 10px;
}

.effect.left.blue_.blueBorder {
  display: flex;
  justify-content: center;
  align-items: center;
  width: min-content;
  /* background: rgb(188, 1, 255, 0.9); */
  background: rgb(107, 92, 209, 0.9);
  border-color: #CD53AE !important;
  height: min-content;
  margin-top: 170px;

  .effectValue {
    color: #FFFFFF;
  }
}

.diagonalLine.blueTopBottom {
  background: linear-gradient(to top right, transparent calc(50% - 2px), rgb(255, 255, 255), transparent calc(50% + 1.5px));
}

.diagonalLine.blueBottomTop {
  background: linear-gradient(to bottom right, transparent calc(50% - 2px), rgb(255, 255, 255), transparent calc(50% + 1.5px));
}

.lineEffect.blueBorder {
  border-color: rgb(255, 255, 255) !important;
  color: white;
}
.root-cause-bplam{
  text-align: left;
  color: #FFFFFF;
  padding-bottom: 10px;
  /* border-bottom: 1px solid #FFFFFF; */
  margin-top: 10px;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.bplam-root-cause-analysis{
  /* height: 1200px; */
  /* height:500px; */
  width: 99.5%;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(116, 123, 169, 1);
  border-radius: 10px;
 
}
.bplam-rca-main{
  background-color: transparent;
  position: relative;
  /* width: 106%; */
 
  height:'fit-content';
  /* height:fit-content */
}
.try-bplam-rca{
  position: absolute;
  margin-left: -570px;
  width: 92%;
  /* height:99%; */
}
.hor-line1{
  position:absolute;
  width:50px;
  /* top:920px; */
  /* top:415px;
  left:380px; */
  top:340px;
  left:420px;
}
.hor-line2{
  position:absolute;
  width:50px;
  /* top:1170px; */
  /* top:665px;
  left:380px; */
  top:615px;
  left:420px;
}
.hor-line3{
  position:absolute;
  width:50px;
  /* top:920px; */
  /* top:415px;
  left:900px; */
  top:340px;
  left:878px;
}
.hor-line4{
  position:absolute;
  width:50px;
  /* top:1170px; */
  top:615px;
  left:878px;
}
.hor-line5{
  position:absolute;
  width:100px;
  height:2px;
  /* width:150px; */
  /* top:1045px; */
  /* top:540px;
  left:432px; */
  top:498px;
  left:477px;
}
.hor-line6{
  position:absolute;
  width:150px;
  height:2px;
  /* top:1045px; */
  /* top:540px;
  left:742px; */
  width:100px;
  top:498px;
  left:768px;
}
.ver-line1{
  position:absolute;
  /* top:920px; */
  /* top:415px;
  left:432px; */
  top:360px;
  left:472px;
}
.ver-line2{
  position:absolute;
  /* top:920px; */
  /* top:360px;
  left:872px; */
  top:360px;
  left:868px;
}
.ver-line3{
  position:absolute;
  /* top:971px; */
  top:421px;
  height:164px;
  width: 25px;
  left:657px;
}
.ver-line4{
  position:absolute;
  /* top:1045px; */
  /* top:540px;
  height:90px;
  left:568px; */
  top:498px;
  height:90px;
  left:565px;
}
.ver-line5{
  position:absolute;
  /* top:1045px; */
  /* top:540px;
  height:90px;
  left:728px; */
  top:498px;
  height:90px;
  left:756px;
}
.bplam-rca-overlay{
  position: absolute;
  margin-left: 5px;
}
.bplam-rca-overlay-part2{
  position: relative;
  margin-left: 10px;
 
  /* padding: 10px; */
  padding-bottom: 30px;
  /* margin-top: 500px; */
  border-radius: 10px;
  /* height:1400px; */
  /* height: fit-content; */
  width:98%;
  background-color: transparent;
  /* background-color: rgba(255, 255, 255, 0.1); */
}
 
.css-14u3pak-control {
  height: 8px;
  min-height: 28px;
  font-size: 10px;
}
.css-1xc3v61-indicatorContainer {
  padding: 1px;
}
 
.bplam-insight-filter-cont {
  padding-bottom: 0px;
  height: 10px;
}

.css-14u3pak-control {
  height: 8px;
  min-height: 28px;
  font-size: 10px;
}

.css-1xc3v61-indicatorContainer {
  padding: 1px;
}

.bplam-insight-filter-cont {
  padding-bottom: 0px;
  height: 10px;
}

.css-piuw2k-control {
  min-height: 25px;
}

.css-1xc3v61-indicatorContainer {
  padding: 1px;
}

.img-filters {
  width: 25px;
}

.bplam-status-value-st {
  color: black;

}

.bplam-status-value {
  color: black;
  font-size: 12px;
}

#mychart1+ul {
  margin-right: 20px;
}

.bplam-status-value-dis {
  color: #AD8BFF;
  font-size: 12px;
}

.bplam-status-dd-container {
  display: flex;
  flex-direction: row;
  margin-left: -18px;
}


/* new */

.bplam-board {
  width: 90vw;
  height: 45vh;
  margin-right: 15px;
  margin-left: 25px;
  margin-top: 15px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  /* background-size: cover; */
  border-radius: 10px;  
  background-size: 100%;
}


.bplam-details-box {
  background-color: rgba(255, 255, 255, 0.1);
  color: aliceblue;
  font-family: 'Graphik';
  /* font-weight: 400; */
  /* font-size: 14px; */
  /* line-height: 10px; */
  border: 1px solid rgba(116, 123, 169, 1);
  border-radius: 10px;
}

.bplam-back{
  width: 20px;
  position: relative;
  left: -42%;
  margin-top : 5%;
}

.radio-option-container{
  color: #FFFFFF;
  font-size: 12px;
  display: flex;
  flex-direction: column;
}
.original-insight-table{
  border: 1px solid #FFFFFF;
  color: 'white';
}
.original-insight-table-header{
  color: #FFFFFF;
  border: 1px solid #FFFFFF;
}
.original-insight-table-body-cell{
  border:1px solid #FFFFFF;
  color: #FFFFFF;
}
.filter-button-form-bplam{
  display: flex;
  flex-direction: column;
  width: 200px;
  height: fit-content;
  text-align: left;
  padding: 5px 10px;
}
/* thead, tbody, tfoot, tr, td, th{
  border: 1px solid #FFFFFF;
} */
.bplam-insights-table-td{
  border: 1px solid #FFFFFF;
  font-size: 12px;
  padding: 10px; 
}
.bplam-insights-table-th{
  border: 1px solid #FFFFFF;
  font-size: 13px;
  font-weight: 700;
  padding: 10px;
}
.all-filter-container-insights-bplam{
  display: flex;
  flex-direction: row;
}


.loader-bplam {
  display: flex;
  margin-left: 150px;
  justify-content: center;
  align-items: center;
  height: 40px;
}

.dot-cq-bplam {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.4s infinite ease-in-out;
  margin-left: 10px;
  margin-bottom: 30px;
}

.red-c-bplam {
  background-color: red;
  animation-delay: -0.32s;
}

.green-c-bplam {
  background-color: green;
  animation-delay: -0.16s;
}

.blue-c-bplam {
  background-color: blue;

}

bplam-insight-filter-sel::placeholder {
  color: rgba(255, 255, 255, 1);
}
.main-bplam-container{
  width: 1150px;
  height: fit-content;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #8d97dac5;
  margin-top: 10px;
  margin-left: 25px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  /* margin-bottom: 20px; */
  background-color: rgba(39, 40, 75, 1); 

}
.radio-opt {
  display: table-cell;
  vertical-align: middle;
  margin-bottom: 2px;
  margin-right: 3px;
}

.bottom-part-chart-chatbot-bplam {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: rgb(54, 54, 89);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border: 1px solid #6B5CD1;
}


/* .btn-check:checked + .btn{
  background-color: #6B5CD1;
  border-color: rgba(116, 123, 169, 1);
  font-weight: 400;
}

.btn-check + .btn:hover {
  color: white;
  border-color: rgba(116, 123, 169, 1);
}

.btn-check + .btn {
color: white;
  border-color: rgba(116, 123, 169, 1);
} */`, "",{"version":3,"sources":["webpack://./src/BPLAM/bplam.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kCAAkC;EAClC,sBAAsB;EACtB,kBAAkB;;AAEpB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;;AAElB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAiCC;AACD;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6IG;AACH;;;;GAIG;AACH;;GAEG;AACH;EACE,gCAAgC;;AAElC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;;AAEpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;;EAEZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;;EAEtB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;AAErB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB;wBACsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,cAAc;EACd,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;;AAElB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;;AAEjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;;AAEjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;;EAEjB,eAAe;;AAEjB;;AAEA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,0CAA0C;EAC1C,cAAc;;AAEhB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;;EAExB,aAAa;;EAEb,mBAAmB;;AAErB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uCAAuC;EACvC,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sCAAsC;EACtC,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;;;AAGlB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB;uBACqB;EACrB,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,0CAA0C;EAC1C,iBAAiB;EACjB,UAAU;EACV,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;;EAEX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;;;AAIA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,iBAAiB;;EAEjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,6CAA6C;;AAE/C;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,6CAA6C;EAC7C,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,4BAA4B;EAC5B,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;;AAEjB;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;;AAEd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;;AAEnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;;;GAMG;;;AAGH,sBAAsB;;AAEtB,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,sCAAsC;AACxC;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,eAAe;EACf,UAAU;EACV,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;;GAGG;AACH;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,gCAAgC;;AAElC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,kCAAkC;EAClC,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;;EAEjB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,yHAAyH;AAC3H;;AAEA;EACE,4HAA4H;AAC9H;;AAEA;EACE,2CAA2C;EAC3C,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,wCAAwC;EACxC,mBAAmB;;AAErB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;;EAEjB,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf;eACa;EACb,SAAS;EACT,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB;eACa;EACb,SAAS;EACT,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf;eACa;EACb,SAAS;EACT,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB;eACa;EACb,SAAS;EACT,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB;eACa;EACb,WAAW;EACX,SAAS;EACT,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,eAAe;EACf;eACa;EACb,SAAS;EACT,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,eAAe;EACf;eACa;EACb,SAAS;EACT,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB;;eAEa;EACb,SAAS;EACT,WAAW;EACX,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB;;eAEa;EACb,SAAS;EACT,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;;EAEjB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;;AAEd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA,QAAQ;;AAER;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,yDAAqD;EACrD,4BAA4B;EAC5B,mBAAmB;EACnB,qBAAqB;AACvB;;;AAGA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;GAEG;AACH;EACE,yBAAyB;EACzB,eAAe;EACf,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;EAC3C,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;;AAExB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;;AAEvC;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iCAAiC;EACjC,+BAA+B;EAC/B,gCAAgC;EAChC,yBAAyB;AAC3B;;;AAGA;;;;;;;;;;;;;;GAcG","sourcesContent":[".bplam-Main-comp {\n  display: flex;\n  font-family: 'Graphik', sans-serif;\n  flex-direction: column;\n  text-align: center;\n\n}\n\n.bplam-screen-container {\n  /* margin-left: 100px; */\n  width: 100%;\n  height: 260px;\n  text-align: center;\n  /* background-color: #142038; */\n  background-color: transparent;\n}\n\n.bplam-screen {\n  width: 95%;\n  height: 100%;\n}\n\n.img-class-comp-bplam {\n\n  margin-left: 900px;\n  margin-right: 5px;\n  /* width: 1150px; */\n  width: 20px;\n}\n\n.img-class-comp2-bplam {\n\n  margin-left: 800px;\n  margin-right: 5px;\n  width: 900px;\n  width: 20px;\n}\n\n.header-comp {\n  width: 1280px;\n  height: 54px;\n}\n\n.header-comp2 {\n  width: 1263px;\n  height: 53px;\n}\n\n.bplam-bottom-comp {\n  display: flex;\n  flex-direction: column;\n  /* background-color: #142038; */\n  background-color: transparent;\n  padding-top: 5px;\n}\n\n.left-comp {\n  display: flex;\n  flex-direction: column;\n}\n\n.section-dropdown {\n  width: 140px;\n  margin-right: 20px;\n  margin-top: 15px;\n  max-height: 20px;\n\n}\n\nmultiSelectContainer input::placeholder {\n  color: black;\n}\n\n.checkbox {\n  margin-right: 10px;\n}\n\n.optionContainer {\n  color: black;\n}\n\n.chip {\n  display: none;\n}\n\n.optionListContainer {\n  background-color: #202342;\n  border-radius: 4px;\n  font-family: 'Graphik';\n  font-size: 12px;\n  color: black;\n  margin-top: 1px;\n  position: absolute;\n  width: 100%;\n  z-index: 2;\n}\n\n.searchWrapper {\n  max-width: 150px;\n  background-color: white;\n  border-radius: 10px;\n  border: 1px solid black;\n  font-family: 'Graphik';\n  color: black;\n  font-size: 12px;\n  overflow: hidden;\n  max-height: 26px;\n}\n\n.title-box-comp {\n  width: 550px;\n  font-size: 13px;\n  font-family: 'Graphik';\n  border-radius: 5px;\n  border: 2px solid white;\n  margin-left: 20px;\n  margin-top: 5px;\n}\n\n/* .right-comp{\n  background-color:rgba(255, 255, 255, 0.03);\n  border-radius:10px;\n  width:100%;\n  margin-right:20px;\n  margin-top:10px;\n  margin-left:35px;\n}\n.under-generate-comp{\n  background-color:rgba(255, 255, 255, 0.1);\n  \n  margin-top:10px;\n  width:100%;\n\n  margin-left: 20px;\n  border-radius: 10px;\n}\n.loader-c {\n  display: flex;\n  margin-left:150px;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n}\n\n.dot-cq {\n  width: 10px;\n  height: 10px;\n  margin: 0 5px;\n  border-radius: 50%;\n  display: inline-block;\n  animation: bounce 1.4s infinite ease-in-out;\n}\n*/\n/*\n.red-c {\n  background-color: red; \n  animation-delay: -0.32s;\n}\n\n.green-c {\n  background-color:green; \n  animation-delay: -0.16s;\n}\n.blue-c {\n  background-color: blue; \n \n}\n.f-comp{\n  color:white;\n  font-weight:500;\n  padding-left:10px;\n  padding-bottom:5px;\n  padding-top:5px;\n}\n.f2-comp{\n  color:white;\n  font-weight:500;\n  padding-left:20px;\n  padding-bottom:5px;\n  padding-top:5px;\n}\n.report-table{\n  max-height:400px;\n \n  margin-left:20px;\n \n}\n.report-table thead {\n    padding-left: 15px;\n  position: sticky;\n  top: 0;\n  background-color: #202342; \n  \n  color: white; \n}\n.report-table-container{\n  overflow-y: scroll;\n  max-height: 350px;\n  max-width: 1150px;\n}\n.report-table th{\n padding-left: 30px;\n  height:40px;\n  overflow: None;\n  color:white;\n  font-size: 14px;\n  background-color:rgba(255, 255, 255, 0.1);\nfont-style: normal;\nfont-weight: 500;\nline-height: normal;\n  border:1px solid rgba(0, 0, 0, 0.10);\n  border-bottom:1px solid rgba(0, 0, 0, 0.10);\n}\n.report-table td {\nborder:  1px solid rgba(0, 0, 0, 0.10); \npadding: 8px; \nfont-family: 'Graphik', sans-serif;\ncolor: white;\ntext-align: left;\nfont-size: 12px;\n\nfont-style: normal;\nfont-weight: 300;\nline-height: normal;\n}\n.f3-comp{\n  color:white;\n  font-weight:500;\n  padding-left:20px;\n  padding-bottom:5px;\n  padding-top:15px;\n}\n.above-comp{\n  padding-bottom:30px;\n  border-bottom:1px solid #8392B6;\n}\n.r2-comp{\n  display:flex;\n  flex-direction:row;\n  padding-left:10px;\n}\n.p-comp{\n  color:white;\n  background-color:#D8AC1B;\n  flex-shrink: 0;\n  padding-left:10px;\n  font-size:10px;\n  padding-top:3px;\n  height:20px;\n  padding-right:10px;   \n  border-radius:12px;\n  margin-right:10px;\n}\n.p1-comp{\n  color:white;\n  padding-top:3px;\n  background-color:#24B600;\n  flex-shrink: 0;\n  padding-left:10px;\n  font-size:10px;\n  height:20px;\n  padding-right:10px;   \n  border-radius:12px;\n  margin-right:10px;\n}\n.d-comp{\n  color:white;\n  font-size:12px;\n  padding-bottom:5px;\n}\n.generate-comp{\n  margin-left: 25px;\n  font-size: 15px;\n  font-weight: 500;\n  margin-top: 10px;\n  color: white;\n}\n.r1-comp{\n  display:flex;\n  flex-direction:row;\n}\n.n2-comp{\n  display:flex;\n  margin-top:10px;\n  flex-direction:row;\n}\n.in-comp{\n  margin-top:8px;\n  padding-right:200px;\n  font-size:13px;\n  padding-top:10px;\n  font-weight: 300;\n  padding-left:80px;\n  color:white;\n} */\n/* .drop-comp{\n  width:200px;\n  border-radius:10px;\n  margin-top:15px;\n} */\n/* .search-insight-bplam{\n  margin-left: 10px;\n} */\n.bplam-insight-filter {\n  border-bottom: 1px solid #AD8BFF;\n\n}\n\n.ref-comp {\n  color: #FFF;\n  padding-left: 20px;\n  padding-top: 15px;\n  font-size: 14px;\n  padding-right: 10px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.file-comp {\n  color: #FFF;\n  padding-top: 18px;\n  font-size: 12px;\n  padding-right: 150px;\n  font-style: normal;\n  font-weight: 300;\n  line-height: normal;\n}\n\n.n1-comp {\n  background-color: rgba(0, 0, 0, 0.10);\n  display: flex;\n  border-radius: 5px;\n  margin-top: 10px;\n  height: 50px;\n  width: 1140px;\n  flex-direction: row;\n  margin-left: 20px;\n  color: white;\n  flex-shrink: 0;\n}\n\n.generate1-comp {\n  margin-left: 10px;\n  padding-bottom: 10px;\n  font-family: 'Graphik';\n  font-size: 15px;\n  font-weight: 500;\n  border-bottom: 1px solid #8392B6;\n  margin-top: 5px;\n  color: white;\n}\n\n.Heading-comp-bplam {\n  color: #fff;\n  font-size: 12px;\n  font-family: 'Graphik';\n  display: flex;\n  flex-direction: row;\n  padding-top: 5px;\n  padding-left: 15px;\n  padding-right: 10px;\n  padding-bottom: 5px;\n  /* background-color: #142038; */\n  background-color: transparent;\n  width: 100%;\n}\n\n.screen-change1-bplam {\n  color: #AD8BFF;\n  width: 120px;\n  font-family: 'Graphik';\n  padding-right: 5px;\n\n}\n\n.screen-change1-bplam1 {\n  color: #AD8BFF;\n  /* width: 50px; */\n  font-family: 'Graphik';\n  padding-right: 5px;\n  margin-left: 10px;\n}\n\n.bplam-comp {\n  font-family: 'Graphik';\n  color: #FFFFFF;\n  width: 160px;\n  padding-right: 5px;\n}\n\n.bplam-comp1 {\n  font-family: 'Graphik';\n  color: #FFFFFF;\n  /* width: 50px; */\n  padding-right: 5px;\n}\n\n.button-comp-bplam {\n  text-align: right;\n  /* margin-top:10px; */\n  margin-bottom: 10px;\n  border-radius: 10px;\n  margin-right: 30px;\n}\n\n.sub-heading-comp {\n  margin-left: 20px;\n  font-size: 15px;\n  font-weight: 400;\n  font-family: 'Graphik';\n  margin-top: 20px;\n  color: white;\n}\n\n.b-c-bplam {\n  background-color: #6B5CD1;\n  border: 2px solid #6B5CD1;\n  color: white;\n  font-size: 12px;\n  font-family: 'Graphik';\n  height: 30px;\n  border-radius: 26px;\n  width: 200px;\n  /* margin-top: 5px; */\n}\n\n.b-c:hover {\n  background-color: #343434;\n  border: 2px solid #343434;\n}\n\n.b1-c {\n  background-color: #6B5CD1;\n  border: 2px solid #6B5CD1;\n  margin-left: 60px;\n  color: white;\n  font-family: 'Graphik';\n  margin-top: 15px;\n  margin-right: 20px;\n  height: 30px;\n  border-radius: 26px;\n  width: 120px;\n}\n\n.b1-c:hover {\n  background-color: #343434;\n  border: 2px solid #343434;\n}\n\n.b2-c {\n  background-color: #6B5CD1;\n  border: 2px solid #6B5CD1;\n  color: white;\n\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: 10px;\n  height: 30px;\n  border-radius: 26px;\n  width: 120px;\n}\n\n.b2-c:hover {\n  background-color: #343434;\n  border: 2px solid #343434;\n}\n\n.b3-c {\n  background-color: #6B5CD1;\n  text-decoration: none;\n  border: 2px solid #6B5CD1;\n  color: white;\n  font-family: 'Graphik';\n\n  margin: 10px;\n  height: 30px;\n  border-radius: 26px;\n  width: 120px;\n}\n\n.b3-c:hover {\n  background-color: #343434;\n  border: 2px solid #343434;\n}\n\n.dropdown-comp {\n  display: flex;\n  margin-top: 10px;\n  flex-direction: row;\n}\n\n.img-comp {\n  width: 60%;\n  margin-left: 10px;\n}\n\n.first-select-comp {\n  display: flex;\n  flex-direction: column;\n}\n\n.first-input-comp {\n  display: flex;\n  margin-left: 20px;\n  width: 270px;\n  flex-direction: row;\n}\n\n/* Add this CSS to your styles or create a new CSS file */\n.popup-bplam {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n}\n\n.popup-content-bplam {\n  background: #1E203D;\n  color: white;\n  font-family: 'Graphik';\n  padding: 5px;\n  /* border-radius: 8px; */\n  border: 1px solid #AD8BFF;\n  border-radius: 10px;\n  height: 75%;\n  width: 35%;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n}\n\n.headers-bplam {\n  background-color: #282c5b;\n  /* padding-left: 30px;\n  padding-right: 30px; */\n  padding-top: 1px;\n  padding-bottom: 10px;\n  width: 100%;\n  height: 40px;\n  border-radius: 8px;\n  text-align: left;\n}\n\n.bplam-close-btn {\n  position: absolute;\n  top: 75px;\n  right: 420px;\n  font-family: 'Graphik';\n  font-size: 30px;\n  cursor: pointer;\n  color: #6B5CD1;\n  background-color: rgba(255, 255, 255, 0.0);\n  border: 0px solid rgba(255, 255, 255, 0.0);\n}\n\n.drop-down-sel-bplam {\n  height: 25px;\n  width: 370px;\n}\n\n.div-container-bplam {\n  padding-left: 30px;\n  padding-right: 30px;\n  padding-bottom: 20px;\n  text-align: left;\n\n}\n\n.title-bplam {\n  margin-top: 2px;\n  height: 30px;\n  width: 200px;\n  font-family: 'Graphik';\n  /* font-weight: bold; */\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.text-bplam {\n  margin-top: 2px;\n  height: 25px;\n  width: 370px;\n}\n\n.company-bplam {\n  margin-top: 2px;\n  height: 30px;\n  width: 200px;\n  font-family: 'Graphik';\n  /* font-weight:bold; */\n  font-weight: 600;\n  font-size: 15px;\n\n}\n\n.dropdown-bplam {\n  margin-top: 2px;\n  height: 25px;\n  width: 450px;\n}\n\n.t-data-bplam {\n  margin-top: 5px;\n  height: 30px;\n  width: 200px;\n  font-family: 'Graphik';\n  /* font-weight: bold; */\n  font-weight: 600;\n  font-size: 15px;\n\n}\n\n.browse {\n  margin-top: 5px;\n  height: 30px;\n  width: 200px;\n}\n\n.analyse-bplam {\n  /* font-weight: bolder; */\n  font-weight: 600;\n  font-family: 'Graphik';\n  margin-top: 10px;\n  margin-left: 20px;\n}\n\n.p-gen-bplam {\n  margin-left: 25px;\n  margin-right: 20px;\n  font-size: 12px;\n  text-align: left;\n}\n\n.drags-bplam {\n\n  margin-right: 2px;\n\n  font-size: 12px;\n\n}\n\n.browses-bplam {\n\n  /* margin-left: 5px; */\n  border: 1px solid #707070;\n  border-radius: 10px;\n  width: 80%;\n  height: 30px;\n  font-family: 'Graphik';\n  font-size: 12px;\n  padding: 5px 25px;\n  margin: 5px 10px 5px 45px;\n  /* margin-top: 50px; */\n  /* margin-left: 30px; */\n  /* background-color: #747BA9; */\n  background-color: rgba(116, 123, 169, 0.7);\n  color: #FFFFFF;\n\n}\n\n.drag-select-container-bplam {\n  padding-top: 5px;\n  /* padding-bottom: 5px; */\n  border: 1px solid #707070;\n  background-color: rgba(116, 123, 169, 0.1);\n  padding-left: 10px;\n  /* background-color: #8392B6; */\n  height: 50px;\n  border-radius: 10px;\n  text-align: center;\n  width: 370px;\n  margin-bottom: 1px;\n  /* margin-left: 280px; */\n\n  display: flex;\n\n  flex-direction: row;\n\n}\n\n.footer-bplam {\n  background-Color: #EFEFEF;\n  color: #707070;\n  padding: 5px;\n  height: 25px;\n  text-align: center;\n  font-size: 10px;\n  font-family: 'Graphik';\n}\n\n.submit1-bplam {\n  width: 90%;\n  height: 30px;\n  border: 1px solid #707070;\n  border-radius: 10px;\n  background-color: #738395;\n  color: #FFFFFF;\n  font-family: 'Graphik';\n}\n\n.bplam-drill-card {\n  /* background-color: #3C4069; */\n  background-color: #3C4069;\n  border: 1px solid #747BA9;\n  border-radius: 8px;\n  /* min-width: 260px; */\n  width: 260px;\n  height: 130px;\n  margin: 10px;\n}\n\n.bplam-drill-card-body {\n  padding: 15px 10px;\n}\n\n.bplam-view-report {\n  width: auto;\n  float: right;\n  cursor: pointer;\n  background-color: rgba(107, 92, 209, 1);\n  color: rgba(255, 255, 255, 1);\n  font-family: 'Graphik';\n  font-size: 12px;\n  font-weight: 400;\n  padding: 2% 4%;\n  border: none;\n  border-radius: 10dvh;\n  margin-top: -40px;\n}\n\n.report-icon {\n  width: 20px;\n  margin-top: 1px;\n  height: 15px;\n}\n\n.bplam-status-drill {\n  max-width: fit-content;\n  margin-top: -6px;\n  padding: 1% 3%;\n  height: fit-content;\n  background-color:  rgba(36, 182, 0, 1);\n  color: rgba(255, 255, 255, 1);\n  font-family: Graphik;\n  font-size: 11px;\n  font-weight: 300;\n  border: none;\n  border-radius: 8dvh;\n  margin-top: 15px;\n  \n\n}\n\n.bplam-drill-header {\n  color: aliceblue;\n  font-family: 'Graphik';\n  font-weight: 600;\n  font-size: 11px;\n  line-height: 5px;\n  text-align: left;\n  /* height: 50px; */\n}\n\n.bplam-drill-body {\n  color: aliceblue;\n  text-align: left;\n  font-family: 'Graphik';\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 5px;\n}\n\n.bplam-drillanalysis-report {\n  padding-left: 20px;\n  padding-top: 10px;\n  /* margin-left: 20px;\n  margin-right: 20px; */\n  display: flex;\n  flex-wrap: wrap;\n  border-top: 1px solid #AD8FFF;\n}\n\n.bplam-Bottom2 {\n  /* background-color: #142038; */\n  background-color: transparent;\n  display: flex;\n  flex-direction: row;\n  margin-left: 50px;\n}\n\n.bplam-bottom-cont {\n  padding-top: 15px;\n  padding-bottom: 15px;\n  background-color: rgba(255, 255, 255, 0.1);\n  margin-left: 30px;\n  width: 95%;\n  /* border:1px solid white; */\n  border-radius: 10px;\n  margin-bottom: 5px;\n}\n\n.bplam-filter-button {\n  width: 70px;\n  margin-left: -10px;\n  color: #738395;\n  font-family: 'Graphik';\n  font-size: 12px;\n  margin-right: 10px;\n  margin-top: 6px;\n}\n\n.bplam-filter-button1 {\n  /* width: 100px; */\n  margin-left: -20px;\n  color: #747BA9;\n  margin-right: 5px;\n  font-family: 'Graphik';\n  font-size: 25px;\n  margin-top: -5px;\n}\n\n.bplam-status-dd {\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 50px;\n  border-color: #AD8BFF;\n  height: 20px;\n  width: 100px;\n  background-color: transparent;\n  margin-left: 10px;\n  margin-top: 5px;\n}\n\n.tab-content-bplam {\n  /* background-color: #142038; */\n  background-color: transparent;\n}\n\n.tab-buttons-bplam {\n  /* background-color: #142038; */\n  background-color: transparent;\n  padding-left: 15px;\n  padding-right: 50px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  text-align: left;\n  width: 100%;\n\n  flex-direction: row;\n  display: flex;\n}\n\n.tab-button.active {\n  background-color: #2ecc71;\n  color: #ffffff;\n  border-bottom: 2px solid #6B5CD1;\n}\n\n.bottom-comp-t1 {\n  height: 80vh;\n  overflow-y: auto;\n  border-radius: 10px;\n  padding: 5px;\n  background-color: transparent;\n  width: 94vw;\n}\n\n.b-upper-ct1 {\n  height: 600px;\n  width: 100%;\n  margin: 5px;\n  display: flex;\n  flex-direction: row;\n  overflow-y: hidden;\n}\n\n\n\n.b-lower-comp-t1 {\n  /* height:50%; */\n  height: 660px;\n  width: 99%;\n  margin-top: 10px;\n  padding-top: 10px;\n\n  margin-right: 5px;\n  margin-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 10px;\n  padding-left: 15px;\n  padding: 5px 50px 5px 50px;\n  /* background-color: rgba(116,123,169,0.5); */\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.b-u-left-ct1 {\n  height: 600px;\n  margin: 5px;\n  width: 60%;\n  border-radius: 10px;\n  /* background-color: rgba(116,123,169,0.5); */\n\n}\n\n.b-u-l-upper-ct1 {\n  height: 80px;\n  width: 98%;\n  border-radius: 10px;\n  margin-top: 10px;\n  margin: 5px;\n  /* background-color: rgba(116,123,169,0.5); */\n  background-color: rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n}\n\n.images-t1 {\n  display: flex;\n  flex-direction: row;\n  margin-top: 10px;\n}\n\n.b-u-l-u-ct1-header {\n  color: #FFFFFF;\n  font-family: 'Graphik', sans-serif;\n  /* font-family: 'Graphik'; */\n  font-size: 14px;\n  /* font-weight: bold; */\n  margin-right: 470px;\n  padding: 2px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.b-u-l-lower-ct1 {\n  height: 495px;\n  width: 98%;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  margin-left: 5px;\n  margin-right: 5px;\n  padding-top: 5px;\n  border-radius: 10px;\n  /* background-color: rgba(116,123,169,0.5); */\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.b-u-right-ct1 {\n  height: 585px;\n  width: 40%;\n  margin-left: 5px;\n  margin-right: 5px;\n  border-radius: 10px;\n  margin-top: 10px;\n  /* margin-bottom:5px; */\n  /* background-color: rgba(116,123,169,0.5); */\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.b-u-r-ct1-header1 {\n  font-family: 'Graphik';\n  font-size: 15px;\n  color: #FFFFFF;\n  text-align: left;\n  margin: 15px 0px 0px 10px;\n}\n\n.b-u-r-ct1-header2 {\n  font-family: 'Graphik';\n  font-size: 8px;\n  color: #FFFFFF;\n  margin-left: 20px;\n  text-align: left;\n}\n.bplam-header-barchart-text{\n  color: #FFFFFF;\n  font-family: 'Graphik';  \n  font-size: 9px; \n  margin-left: 10px;\n}\n.bplam-header-barchart{\n  color: #FFFFFF;\n  font-family: 'Graphik';   \n  font-size: 14px;\n  font-weight: 500;\n  margin-left: 10px;\n}\n.date-range {\n  border: 1px solid #6B5CD1;\n  background-color: #6B5CD1;\n  border-radius: 10px;\n  padding: 5px;\n  width: 45px;\n  height: 40px;\n  margin-left: 10px;\n  margin-top: 2px;\n}\n\n.assecending-bplam {\n  position: absolute;\n  top: 50px;\n  right: 50px;\n  padding: 8px;\n  background-color: transparent;\n  color: #fff;\n  border-radius: 5px;\n  cursor: pointer;\n  border: 1px solid #e6c520;\n}\n\n.date-range-text2 {\n  font-size: 12px;\n  /* margin-top: -15px; */\n  text-align: left;\n  margin-left: 10px;\n  color: white;\n}\n\n.tot-ticket {\n  border: 1px solid #6B5CD1;\n  background-color: #6B5CD1;\n  border-radius: 10px;\n  padding: 7px;\n  width: 45px;\n  height: 40px;\n  margin-top: 2px;\n  /* margin-left: 65px; */\n  margin-left: 120px;\n}\n\n.tot-apps {\n  border: 1px solid #6B5CD1;\n  background-color: #6B5CD1;\n  border-radius: 10px;\n  padding: 6px;\n  width: 45px;\n  height: 40px;\n  /* margin-left: 70px; */\n  margin-left: 120px;\n  margin-top: 2px;\n}\n\n.date-range-text {\n  color: #FFFFFF;\n  font-family: 'Graphik';\n  font-size: 14px;\n  font-weight: bold;\n  width: fit-content;\n  margin-left: 10px;\n  /* margin-bottom: 5px; */\n}\n\n.tot-tic-text {\n  color: #FFFFFF;\n  font-family: 'Graphik';\n  font-size: 14px;\n  font-weight: bold;\n  margin: 1px;\n}\n\n.tot-tic-text2 {\n  color: #FFFFFF;\n  font-size: 12px;\n  font-family: 'Graphik';\n  /* margin: 3px; */\n  width: fit-content;\n}\n\n.tot-app-text {\n  color: #FFFFFF;\n  /* font-family: 'Graphik'; */\n  font-family: 'Graphik', sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  margin: 1px;\n}\n\n.tot-app-text2 {\n  color: #FFFFFF;\n  font-family: 'Graphik', sans-serif;\n  font-size: 10px;\n  margin: 3px;\n  width: fit-content;\n}\n\n.ts {\n  margin-left: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.hmt-header {\n  background-color: rgba(255, 255, 255, 0.0);\n  color: #FFFFFF;\n  font-size: 14px;\n  text-align: left;\n\n  margin-top: 5px;\n}\n\n.heatmap-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n  height: 93%;\n}\n\n.heatmap-table-th,\n.heatmap-table-td {\n  border: 1px solid #ddd;\n  padding: 2px;\n  text-align: center;\n  font-size: 12px;\n\n}\n\n.heatmap-table-th {\n  /* background-color: #f2f2f2; */\n  background-color: rgb(107, 92, 209);\n  height: 50px;\n  color: #FFF;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 8px;\n}\n\n.heatmap-table-td {\n  color: #FFFFFF;\n  font-size: 12px;\n}\n\n.heatmap-table-td1 {\n  /* background-color: purple; */\n  background-color: rgb(54, 57, 85);\n  color: #FFFFFF;\n  font-size: 12px;\n  border: 1px solid #ddd;\n  padding: 8px;\n  /* font-weight: bold; */\n}\n\n.heatmap-table tbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.heatmap-table tbody tr:hover {\n  background-color: #e5e5e5;\n}\n\n.nested-bplam {\n  height: 300px;\n  width: 400px;\n}\n\n.insights-table-bplam {\n  color: white;\n\n}\n\n.bplam-insight-filter {\n  display: flex;\n  flex-direction: row;\n  margin-left: 20px;\n\n}\n\n.bplam-insight-filter-cont {\n  display: flex;\n  flex-direction: row;\n}\n\n.bplam-insight-filter-label {\n  color: white;\n  font-size: 10px;\n  font-weight: bold;\n  font-family: 'Graphik', 'sans-serif';\n}\n\n.b-i-f-header {\n  color: #738395;\n  font-size: 12px;\n  margin-top: 15px;\n  margin-right: 10px;\n  margin-left: 15px;\n}\n\n.bplam-tab2-insights {\n  background-color: rgba(255, 255, 255, 0.1);\n  padding: 10px;\n  border: 1px solid rgba(116, 123, 169, 1);\n  border-radius: 10px;\n  width: 98%;\n  margin: 10px 15px;\n}\n\n.bplam-tab2-insights-header {\n  color: #FFFFFF;\n  font-family: 'Graphik', 'sans-serif';\n  font-weight: 500;\n  text-align: left;\n  margin-top: 10px;\n  margin-left: 20px;\n  margin-bottom: 10px;\n}\n\n/* .bplam-insight-filter-sel{\n  height: 41px;\n  width: 120px;\n  border: 1.5px solid #AD8BFF;\n  border-radius: 10px;\n  background-color: #142038;\n} */\n\n\n/* FishboneChart.css */\n\n/* Styling for the diagram widget container */\n.DiagramWidget {\n  background-color: #f0f0f0;\n  border: 1px solid #ccc;\n  overflow: hidden;\n}\n\n/* Styling for nodes */\n.DiagramNode {\n  background-color: #fff;\n  border: 1px solid #999;\n  padding: 10px;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n}\n\n/* Styling for node labels */\n.DiagramNode .name {\n  font-size: 14px;\n  font-weight: bold;\n}\n\n/* Styling for node ports */\n.DiagramPort {\n  background-color: #333;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n/* Styling for links */\n.DiagramLink {\n  stroke: #333;\n  stroke-width: 2;\n  fill: none;\n  marker-end: url(#arrowhead);\n}\n\n/* Styling for link labels */\n.DiagramLink .diagram-link-label {\n  font-size: 12px;\n  fill: #333;\n}\n\n/* Styling for link arrowhead */\n#arrowhead {\n  width: 10px;\n  height: 10px;\n  fill: #333;\n}\n\n/* Styling for node counts */\n.DiagramNode .diagram-node-count {\n  font-size: 12px;\n  color: #333;\n}\n\n/* *, *::before, *::after {\n  box-sizing: border-box;\n  color: white;\n} */\n.rootCauses {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-end;\n  flex: 3;\n  font-size: 0.85em;\n  font-weight: 400;\n  color: #FFFFFF;\n  text-align: right;\n  padding: 10px 2px;\n}\n\n.cause.top.blue.blueBorder {\n  color: white;\n}\n\n.cause.top.blue_.blueBorder {\n  background: rgb(188, 1, 255, 0.9);\n  color: #FFFFFF;\n  border-color: #CD53AE !important;\n\n}\n\n.cause.bottom.blue_.blueBorder {\n  background: rgb(105, 97, 178, 0.9);\n  color: #FFFFFF;\n  border-color: #CD53AE !important;\n}\n\n.effectValue {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 0.95em;\n  font-weight: 400;\n  color: #FFFFFF;\n  padding: 5px 10px 5px 10px;\n}\n\n.effect.left.blue_.blueBorder {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: min-content;\n  /* background: rgb(188, 1, 255, 0.9); */\n  background: rgb(107, 92, 209, 0.9);\n  border-color: #CD53AE !important;\n  height: min-content;\n  margin-top: 170px;\n\n  .effectValue {\n    color: #FFFFFF;\n  }\n}\n\n.diagonalLine.blueTopBottom {\n  background: linear-gradient(to top right, transparent calc(50% - 2px), rgb(255, 255, 255), transparent calc(50% + 1.5px));\n}\n\n.diagonalLine.blueBottomTop {\n  background: linear-gradient(to bottom right, transparent calc(50% - 2px), rgb(255, 255, 255), transparent calc(50% + 1.5px));\n}\n\n.lineEffect.blueBorder {\n  border-color: rgb(255, 255, 255) !important;\n  color: white;\n}\n.root-cause-bplam{\n  text-align: left;\n  color: #FFFFFF;\n  padding-bottom: 10px;\n  /* border-bottom: 1px solid #FFFFFF; */\n  margin-top: 10px;\n  margin-left: 20px;\n  margin-right: 20px;\n  margin-bottom: 20px;\n}\n.bplam-root-cause-analysis{\n  /* height: 1200px; */\n  /* height:500px; */\n  width: 99.5%;\n  background-color: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(116, 123, 169, 1);\n  border-radius: 10px;\n \n}\n.bplam-rca-main{\n  background-color: transparent;\n  position: relative;\n  /* width: 106%; */\n \n  height:'fit-content';\n  /* height:fit-content */\n}\n.try-bplam-rca{\n  position: absolute;\n  margin-left: -570px;\n  width: 92%;\n  /* height:99%; */\n}\n.hor-line1{\n  position:absolute;\n  width:50px;\n  /* top:920px; */\n  /* top:415px;\n  left:380px; */\n  top:340px;\n  left:420px;\n}\n.hor-line2{\n  position:absolute;\n  width:50px;\n  /* top:1170px; */\n  /* top:665px;\n  left:380px; */\n  top:615px;\n  left:420px;\n}\n.hor-line3{\n  position:absolute;\n  width:50px;\n  /* top:920px; */\n  /* top:415px;\n  left:900px; */\n  top:340px;\n  left:878px;\n}\n.hor-line4{\n  position:absolute;\n  width:50px;\n  /* top:1170px; */\n  top:615px;\n  left:878px;\n}\n.hor-line5{\n  position:absolute;\n  width:100px;\n  height:2px;\n  /* width:150px; */\n  /* top:1045px; */\n  /* top:540px;\n  left:432px; */\n  top:498px;\n  left:477px;\n}\n.hor-line6{\n  position:absolute;\n  width:150px;\n  height:2px;\n  /* top:1045px; */\n  /* top:540px;\n  left:742px; */\n  width:100px;\n  top:498px;\n  left:768px;\n}\n.ver-line1{\n  position:absolute;\n  /* top:920px; */\n  /* top:415px;\n  left:432px; */\n  top:360px;\n  left:472px;\n}\n.ver-line2{\n  position:absolute;\n  /* top:920px; */\n  /* top:360px;\n  left:872px; */\n  top:360px;\n  left:868px;\n}\n.ver-line3{\n  position:absolute;\n  /* top:971px; */\n  top:421px;\n  height:164px;\n  width: 25px;\n  left:657px;\n}\n.ver-line4{\n  position:absolute;\n  /* top:1045px; */\n  /* top:540px;\n  height:90px;\n  left:568px; */\n  top:498px;\n  height:90px;\n  left:565px;\n}\n.ver-line5{\n  position:absolute;\n  /* top:1045px; */\n  /* top:540px;\n  height:90px;\n  left:728px; */\n  top:498px;\n  height:90px;\n  left:756px;\n}\n.bplam-rca-overlay{\n  position: absolute;\n  margin-left: 5px;\n}\n.bplam-rca-overlay-part2{\n  position: relative;\n  margin-left: 10px;\n \n  /* padding: 10px; */\n  padding-bottom: 30px;\n  /* margin-top: 500px; */\n  border-radius: 10px;\n  /* height:1400px; */\n  /* height: fit-content; */\n  width:98%;\n  background-color: transparent;\n  /* background-color: rgba(255, 255, 255, 0.1); */\n}\n \n.css-14u3pak-control {\n  height: 8px;\n  min-height: 28px;\n  font-size: 10px;\n}\n.css-1xc3v61-indicatorContainer {\n  padding: 1px;\n}\n \n.bplam-insight-filter-cont {\n  padding-bottom: 0px;\n  height: 10px;\n}\n\n.css-14u3pak-control {\n  height: 8px;\n  min-height: 28px;\n  font-size: 10px;\n}\n\n.css-1xc3v61-indicatorContainer {\n  padding: 1px;\n}\n\n.bplam-insight-filter-cont {\n  padding-bottom: 0px;\n  height: 10px;\n}\n\n.css-piuw2k-control {\n  min-height: 25px;\n}\n\n.css-1xc3v61-indicatorContainer {\n  padding: 1px;\n}\n\n.img-filters {\n  width: 25px;\n}\n\n.bplam-status-value-st {\n  color: black;\n\n}\n\n.bplam-status-value {\n  color: black;\n  font-size: 12px;\n}\n\n#mychart1+ul {\n  margin-right: 20px;\n}\n\n.bplam-status-value-dis {\n  color: #AD8BFF;\n  font-size: 12px;\n}\n\n.bplam-status-dd-container {\n  display: flex;\n  flex-direction: row;\n  margin-left: -18px;\n}\n\n\n/* new */\n\n.bplam-board {\n  width: 90vw;\n  height: 45vh;\n  margin-right: 15px;\n  margin-left: 25px;\n  margin-top: 15px;\n  background-repeat: no-repeat;\n  background-image: url('../images/image 41-bplam.svg');\n  /* background-size: cover; */\n  border-radius: 10px;  \n  background-size: 100%;\n}\n\n\n.bplam-details-box {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: aliceblue;\n  font-family: 'Graphik';\n  /* font-weight: 400; */\n  /* font-size: 14px; */\n  /* line-height: 10px; */\n  border: 1px solid rgba(116, 123, 169, 1);\n  border-radius: 10px;\n}\n\n.bplam-back{\n  width: 20px;\n  position: relative;\n  left: -42%;\n  margin-top : 5%;\n}\n\n.radio-option-container{\n  color: #FFFFFF;\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n}\n.original-insight-table{\n  border: 1px solid #FFFFFF;\n  color: 'white';\n}\n.original-insight-table-header{\n  color: #FFFFFF;\n  border: 1px solid #FFFFFF;\n}\n.original-insight-table-body-cell{\n  border:1px solid #FFFFFF;\n  color: #FFFFFF;\n}\n.filter-button-form-bplam{\n  display: flex;\n  flex-direction: column;\n  width: 200px;\n  height: fit-content;\n  text-align: left;\n  padding: 5px 10px;\n}\n/* thead, tbody, tfoot, tr, td, th{\n  border: 1px solid #FFFFFF;\n} */\n.bplam-insights-table-td{\n  border: 1px solid #FFFFFF;\n  font-size: 12px;\n  padding: 10px; \n}\n.bplam-insights-table-th{\n  border: 1px solid #FFFFFF;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 10px;\n}\n.all-filter-container-insights-bplam{\n  display: flex;\n  flex-direction: row;\n}\n\n\n.loader-bplam {\n  display: flex;\n  margin-left: 150px;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n}\n\n.dot-cq-bplam {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n  animation: bounce 1.4s infinite ease-in-out;\n  margin-left: 10px;\n  margin-bottom: 30px;\n}\n\n.red-c-bplam {\n  background-color: red;\n  animation-delay: -0.32s;\n}\n\n.green-c-bplam {\n  background-color: green;\n  animation-delay: -0.16s;\n}\n\n.blue-c-bplam {\n  background-color: blue;\n\n}\n\nbplam-insight-filter-sel::placeholder {\n  color: rgba(255, 255, 255, 1);\n}\n.main-bplam-container{\n  width: 1150px;\n  height: fit-content;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  border-color: #8d97dac5;\n  margin-top: 10px;\n  margin-left: 25px;\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n  /* margin-bottom: 20px; */\n  background-color: rgba(39, 40, 75, 1); \n\n}\n.radio-opt {\n  display: table-cell;\n  vertical-align: middle;\n  margin-bottom: 2px;\n  margin-right: 3px;\n}\n\n.bottom-part-chart-chatbot-bplam {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background-color: rgb(54, 54, 89);\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border: 1px solid #6B5CD1;\n}\n\n\n/* .btn-check:checked + .btn{\n  background-color: #6B5CD1;\n  border-color: rgba(116, 123, 169, 1);\n  font-weight: 400;\n}\n\n.btn-check + .btn:hover {\n  color: white;\n  border-color: rgba(116, 123, 169, 1);\n}\n\n.btn-check + .btn {\ncolor: white;\n  border-color: rgba(116, 123, 169, 1);\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
